import loadable from '@loadable/component';

export const OrgDashboardManageContactsPageContainerLoadable = loadable(
  () => import('./OrgDashboardManageContactsPageContainer'),
  {
    resolveComponent: (module) =>
      module.OrgDashboardManageContactsPageContainer,
  },
);
